import { render, staticRenderFns } from "./IconManagementEnseignants.vue?vue&type=template&id=d8ab4852&"
import script from "./IconManagementEnseignants.vue?vue&type=script&lang=ts&"
export * from "./IconManagementEnseignants.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports